import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { registerAlertHandler } from "../../Utils/alertService";
import {
  BsCheckCircleFill,
  BsExclamationCircleFill,
  BsInfoCircleFill,
  BsExclamationTriangleFill,
} from "react-icons/bs";

const typeConfig = {
  success: {
    variant: "success",
    icon: <BsCheckCircleFill className="me-2" />,
  },
  danger: {
    variant: "danger",
    icon: <BsExclamationCircleFill className="me-2" />,
  },
  warning: {
    variant: "warning",
    icon: <BsExclamationTriangleFill className="me-2" />,
  },
  info: {
    variant: "info",
    icon: <BsInfoCircleFill className="me-2" />,
  },
};

const GlobalAlert = () => {
  const [alert, setAlert] = useState(null);

  // Register global handler once
  useEffect(() => {
    registerAlertHandler((config) => {
      const {
        type = "info",
        title,
        message,
        duration = 3000, // ms
      } = config || {};

      setAlert({
        id: Date.now(),
        type,
        title,
        message,
        duration,
      });
    });
  }, []);

  // Auto close timer
  useEffect(() => {
    if (!alert) return;

    const timer = setTimeout(() => {
      setAlert(null);
    }, alert.duration);

    return () => clearTimeout(timer);
  }, [alert]);

  if (!alert) return null;

  const cfg = typeConfig[alert.type] || typeConfig.info;

  return (
    <div
      className="position-fixed top-0 end-0 p-3"
      style={{ zIndex: 2000 }}
    >
      <Alert
        variant={cfg.variant}
        dismissible
        onClose={() => setAlert(null)}
        className="d-flex align-items-start shadow-sm"
      >
        <div className="me-2 mt-1">{cfg.icon}</div>
        <div>
          {alert.title && <div className="fw-bold mb-1">{alert.title}</div>}
          {alert.message && <div>{alert.message}</div>}
        </div>
      </Alert>
    </div>
  );
};

export default GlobalAlert;
